import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonSubmit: {
    marginBottom: 10,
  },
  errorBox: {
    border: 'solid 2px rgba(252, 80, 80, .87)',
    backgroundColor: 'rgba(255, 186, 186, .6)',
    color: '#d8000c'
  }
}));